export const useSitePagePartial = () => {
    const makeClickable = (element: HTMLElement | null): void =>  {
        let link = element?.querySelector(".link-button") as HTMLAnchorElement ?? 
            element?.querySelector(".site-page-partial__link") as HTMLAnchorElement;
        window.location.href = link.getAttribute('href') as string;
    }

    const initializeEventListeners = () => {
        // Add anchor link click event listeners to the whole block if whole link is active
        (document.querySelectorAll('.site-page-partial__content--whole-link') as NodeListOf<HTMLElement>)
            .forEach((generalBlockElement) => {
                generalBlockElement.addEventListener('click', () => {
                    makeClickable(generalBlockElement);
                });
                generalBlockElement.addEventListener('keyup', (event) => {
                    if (event?.key === 'Enter') {
                        makeClickable(generalBlockElement);
                    }
                });
            });
    }

    initializeEventListeners();
};

// Run the function on page load
useSitePagePartial();